import { useEffect, useRef, useState } from 'react';
import { LoaderCircle } from 'lucide-react';
import { Button } from './ui/button';

let scriptPromise;
function loadStripeButton(url) {
  if (window.customElements.get('stripe-buy-button')) return Promise.resolve();
  if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url; script.async = true; script.dataset.studioStripeButton = 'true';
    const timer = setTimeout(() => { script.remove(); scriptPromise = null; reject(new Error('Stripe took too long to load.')); }, 15000);
    script.onerror = () => { clearTimeout(timer); script.remove(); scriptPromise = null; reject(new Error('Stripe could not load. Check your connection or content blocker.')); };
    script.onload = () => { window.customElements.whenDefined('stripe-buy-button').then(() => { clearTimeout(timer); resolve(); }); };
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export const StripeBuyButton = ({ config }) => {
  const host = useRef(null), [state, setState] = useState('loading'), [error, setError] = useState(''), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false, observer, timer;
    setState('loading'); setError('');
    const mount = async () => {
      try {
        await loadStripeButton(config.script_url);
        if (cancelled || !host.current) return;
        const element = document.createElement('stripe-buy-button');
        element.setAttribute('buy-button-id', config.button_id);
        element.setAttribute('publishable-key', config.publishable_key);
        element.setAttribute('client-reference-id', config.client_reference_id);
        element.setAttribute('data-testid', 'customer-stripe-buy-button');
        host.current.replaceChildren(element);
        const watchFrame = () => {
          const frame = element.querySelector('iframe') || element.shadowRoot?.querySelector('iframe');
          if (frame) { frame.title = 'Stripe hosted payment button'; frame.addEventListener('load', () => { if (!cancelled) { setState('ready'); clearTimeout(timer); } }, { once: true }); observer?.disconnect(); }
        };
        observer = new MutationObserver(watchFrame);
        observer.observe(element, { childList: true, subtree: true });
        watchFrame();
        timer = setTimeout(() => { if (!cancelled) { setState('slow'); setError('If the Stripe button has not appeared, reload it or contact the studio. No payment has been confirmed.'); } }, 16000);
      } catch (e) { if (!cancelled) { setError(e.message); setState('error'); } }
    };
    mount();
    return () => { cancelled = true; observer?.disconnect(); clearTimeout(timer); };
  }, [config.button_id, config.publishable_key, config.client_reference_id, config.script_url, attempt]);
  return <div className="customer-stripe-button"><div ref={host} data-testid="customer-stripe-button-host" />{state === 'loading' && <p className="payment-widget-loading" data-testid="customer-stripe-loading"><LoaderCircle className="animate-spin" size={16} />Loading Stripe’s payment button…</p>}{error && <div className="form-error" role="alert" data-testid="customer-stripe-error"><p>{error}</p><Button variant="outline" onClick={() => setAttempt(n => n + 1)} data-testid="customer-stripe-retry">Reload Stripe button</Button></div>}</div>;
};